<template>
  <div class="col-4">
    <div
      class="
        panel-content-inner
        platform-background
        rental-parameter-item
        height-100-p
      "
    >
      <div class="panel-header text-align-center">
        <h4 class="inner-title">
          {{ $t("account.settings.user_platforms_section.special_features") }}
        </h4>
      </div>
      <div class="panel-content form-group show">
        <div class="row">
          <div class="col-10 pl-0 pr-2 m-t-10 d-flex">
            <div class="form-group form-material">
              <div class="checkbox-custom checkbox-inline checkbox-primary">
                <input
                  type="checkbox"
                  id="gap_fill"
                  v-model="rentalGapFillField"
                  @change="updateRentalGapFillField"
                />
                <label for="gap_fill">{{
                  $t("account.settings.user_platforms_section.gap_fill")
                }}</label>
              </div>
            </div>
          </div>

          <div class="col-6 pl-0 pr-2">
            <div class="form-group form-material">
              <select
                class="form-control"
                v-if="rentalGapFillField"
                v-model="rentalGapFillPercentField"
                @change="updateRentalGapFillPercent"
              >
                <option
                  v-for="percentAmount in percentAmounts"
                  :value="percentAmount"
                >
                  {{ percentAmount }}
                </option>
              </select>
            </div>
          </div>

          <div v-show="showDynamicPrice()" class="col-8 pl-0 mb-10">
            <div class="checkbox-custom checkbox-inline checkbox-primary">
              <input
                type="checkbox"
                id="dynamic-price"
                name="dynamic-price"
                v-model="dynamicPriceField"
                @change="updateDynamicPrice"
              />
              <label for="dynamic-price">
                {{ $t("rentals.detail.service_tab.dynamic_price") }}</label
              >
            </div>
            <div class="row col-8" v-if="dynamicPriceField">
              <div class="mt-15">
                <img
                  src="static/assets/images/SuperHote_icons/sync.svg"
                  id="sync-btn"
                  alt="NO IMAGE"
                  class="sync-room-dates-icon"
                  @click="syncDynamicPrice"
                />
                <label for="sync-btn" class="sync-text">{{
                  $t("rentals.detail.service_tab.synchronize")
                }}</label>
              </div>
              <div class="mt-5 col-2">
                <button
                  type="button"
                  class="btn btn-primary btn-save"
                  @click="openModal('#dynamic-price-modal')"
                >
                  {{ $t("menu.settings") }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <!--          <div class="row">-->
        <!--            <div class="col-8 pl-0">-->
        <!--              <div class="form-group form-material">-->
        <!--                <label for="default-inventory"><b>{{ $t('default_inventory') }}:</b></label>-->
        <!--                <input-->
        <!--                  id="default-inventory"-->
        <!--                  type="text"-->
        <!--                  class="form-control"-->
        <!--                  name="default_inventory"-->
        <!--                  v-model="defaultInventoryField"-->
        <!--                >-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <div class="row">
          <div class="col-8 pl-0">
            <div class="form-group form-material">
              <div class="form-group form-material">
                <label class="control-label">
                  <b>{{ $t("input.min_days_until_checkin") }}:</b>
                </label>
                <select
                  class="form-control"
                  v-model="minDaysUntilCheckin"
                  id="min-days-until-check-in"
                >
                  <option :value="null">{{ $t("input.no_limit") }}</option>
                  <option v-for="i in 7" :value="i">{{ i }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div id="reduction" class="row align-items-center">
          <div class="col-12 pl-0 mb-4">
            <b>{{ $t("price_reduction") }}:</b>
            <span>
            <i
              data-toggle="popover"
              data-trigger="manual"
              :data-content="$t('price_reduction_info')"
              class="fa fa-info-circle fa-specified rental-detail-popover"
            ></i>
          </span>
          </div>
          <label class="control-label col-6">
            {{ $t("price_reduction_desc") }}
          </label>
          <div class="col-8 reduction-btn-container m-b-10">
            <button
              type="button"
              class="
                btn btn-primary
                waves-effect waves-classic
                btn-with-caret btn-save
              "
              @click="openModal('#reductions')"
            >
              {{ $t("button.add_reduction") }}
            </button>
          </div>
          <div
            class="modal fade"
            id="reductions"
            aria-hidden="false"
            aria-labelledby="exampleGrid"
            role="dialog"
          >
            <div class="modal-dialog modal-simple modal-center">
              <div class="modal-content">
                <div class="modal-header">
                  <div class="container">
                    <div class="row header">
                      <div class="col-8"></div>
                      <div class="col-4">
                        <button
                          type="button"
                          class="close"
                          data-dismiss="modal"
                          aria-label="Close"
                          @click.prevent="closeReductionModal()"
                        >
                          <span aria-hidden="true" class="close-btn"
                            >&times;</span
                          >
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-6 pl-0">
                      <div class="form-group form-material">
                        <label class="control-label">
                          {{ $t("account.settings.payment_rules.period") }}
                        </label>
                        <input
                          id="price-reduction-days"
                          type="number"
                          class="form-control"
                          name="price_reduction_days"
                          v-model="numberOfDays"
                        />
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group form-material">
                        <label
                          class="control-label"
                          for="price-reduction-percent"
                        >
                          {{ $t("account.settings.payment_rules.percent") }}
                        </label>
                        <input
                          id="price-reduction-percent"
                          type="number"
                          class="form-control"
                          name="price_reduction_percent"
                          v-model="percent"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="modal-footer justify-content-center">
                  <button
                    type="button"
                    class="btn waves-effect waves-classic btn-cancel"
                    data-dismiss="modal"
                    @click="closeReductionModal()"
                  >
                    {{ $t("button.cancel") }}
                  </button>
                  <div class="upload">
                    <button
                      type="button"
                      class="
                        btn btn-primary
                        waves-effect waves-classic
                        btn-save
                      "
                      @click.prevent="addReduction()"
                    >
                      {{ $t("button.save") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="modal fade"
            id="dynamic-price-modal"
            aria-hidden="false"
            aria-labelledby="exampleGrid"
            role="dialog"
          >
            <div class="modal-dialog modal-simple modal-center">
              <div class="modal-content">
                <form autocomplete="off">
                  <div class="modal-header">
                    <div class="container">
                      <div class="row header">
                        <div class="col-8 font-size-30">
                          <h4 class="modal-title">{{ rentalName }}</h4>
                        </div>
                        <div class="col-4">
                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click.prevent="closeDynamicPriceModal()"
                          >
                            <span aria-hidden="true" class="close-btn"
                              >&times;</span
                            >
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal-body">
                    <div class="row m-t-10">
                      <div class="col-6 pl-0">
                        <div class="form-group form-material">
                          <label class="control-label">
                            {{ $t("rentals.detail.service_tab.min_price") }}
                          </label>
                          <input
                            id="dynamic-price-minimum"
                            type="text"
                            class="form-control"
                            v-model="minPrice"
                          />
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="form-group form-material">
                          <label
                            class="control-label"
                            for="price-reduction-percent"
                          >
                            {{ $t("rentals.detail.service_tab.base_price") }}
                          </label>
                          <input
                            id="dynamic-price-base"
                            type="text"
                            class="form-control"
                            v-model="basePrice"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="form-group row m-t-10">
                      <label class="control-label">
                        {{
                          $t("rentals.detail.service_tab.listing_competitors")
                        }}
                      </label>
                      <textarea
                        class="form-control"
                        autofocus="autofocus"
                        v-model="listingCompetitors"
                        cols="30"
                        rows="3"
                      />
                    </div>
                    <div class="form-group row m-t-10">
                      <label class="control-label">
                        {{ $t("rentals.detail.service_tab.spec_prices") }}
                      </label>
                      <textarea
                        class="form-control"
                        autofocus="autofocus"
                        v-model="specPrice"
                        cols="30"
                        rows="3"
                      />
                    </div>
                  </div>
                  <div class="modal-footer justify-content-center">
                    <button
                      type="button"
                      class="btn waves-effect waves-classic btn-cancel"
                      data-dismiss="modal"
                      @click.prevent="closeDynamicPriceModal()"
                    >
                      {{ $t("button.cancel") }}
                    </button>
                    <div>
                      <button
                        type="button"
                        class="
                          btn btn-primary
                          waves-effect waves-classic
                          btn-save
                        "
                        data-dismiss="modal"
                        @click.prevent="saveDynamicPriceSettings()"
                      >
                        {{ $t("button.save") }}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div class="row">
            <div
              class="col-12"
              v-for="(reduction, index) in modifiedReductions"
            >
              {{
                `${reduction.percent}% ${$t(
                  "account.settings.payment_rules.reduction"
                )} ${$t("for")} ${reduction.day} ${$t(
                  "account.settings.payment_rules.days"
                )}`
              }}
              <span
                class="cursor-pointer reduction-trash"
                @click="deleteReduction(reduction.id, index)"
                ><i
                  :class="`${
                    reduction.isDeleting ? 'disableTrash' : ''
                  } fa fa-trash`"
                ></i
              ></span>
            </div>
          </div>
        </div>
        <hr />
      </div>
      <div v-if="!(account.is_team_member || rentals.length === 1)">
        <v-loading
          :isLoading="smallLoading"
          :height="50"
          :width="50"
          :viewbox="'0 0 50 50'"
          :cx="25"
          :cy="25"
          :r="22"
          :isHeightAuto="true"
        ></v-loading>
        <div
          id="rental-dependency-container"
          class="panel-content form-group show m-t-25 filter-by-rental"
          v-if="!smallLoading"
        >
          <div v-if="rentals.length === 1" class="row">
            <label class="control-label mr-15">
              {{ $t("rentals.detail.parameters.all_rentals_depended") }}
            </label>
          </div>
          <div class="row" v-else-if="modifiedGroups.length">
            <div class="dep-part">
              <div class="mb-4">
                <b>{{ $t("rentals.detail.parameters.availability_title") }} </b>
              </div>
              <label class="control-label col-8">
                {{ $t("rentals.detail.parameters.requires_availability") }}
              </label>
              <div class="dependencies-section">
                <div class="dependencies-button">
                  <button
                    class="btn btn-secondary btn-lg dropdown-toggle"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    {{ $t("automation.index.select_rentals") }}
                  </button>
                  <div
                    class="dropdown-menu"
                    aria-labelledby="navbarDropdown"
                    id="rental-dependency-dropdown"
                  >
                    <ul
                      class="
                        checkbox-custom
                        m-l-30
                        checkbox-primary
                        dependency-container
                      "
                    >
                      <ul
                        v-for="group in modifiedGroups"
                        class="checkbox-custom m-l-30 checkbox-primary"
                        style="margin-left: 10px"
                      >
                        <input
                          type="checkbox"
                          @change="filterByRentals(group.id)"
                          v-model="checkedGroups[group.id]"
                          :id="group.name"
                        />
                        <label :for="group.name">
                          <span class="rental-name">{{ group.name }}</span>
                        </label>
                        <li
                          v-for="rental in group.rentals"
                          class="checkbox-custom checkbox-primary dropdown-item"
                        >
                          <input
                            type="checkbox"
                            @change="filterByRentals()"
                            v-model="checkedRentals[rental.id]"
                            :id="rental.name"
                          />
                          <label :for="rental.name">
                            <span class="rental-name">{{ rental.name }}</span>
                          </label>
                        </li>
                      </ul>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="row">
            <label class="control-label mr-15">
              {{ $t("rentals.detail.parameters.all_rentals_depended") }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import _ from "lodash";
import rentalService from "./../../../services/rental";
import mixin from "../../../mixins/mixin";

export default {
  name: "SpecialFeatures",
  props: [
    "rentalGapFill",
    "defaultInventory",
    "rentalMinDaysUntilCheckin",
    "priceReductionForPeriod",
    "rentalId",
    "dependencies",
    "dynamicPrice",
    "percentAmounts",
    "rentalGapFillPercent",
    "rentalName",
    "dynamicPriceSettings",
  ],
  data() {
    return {
      rentalGapFillField: this.rentalGapFill,
      rentalGapFillPercentField: this.rentalGapFillPercent || 0,
      defaultInventoryField: this.defaultInventory,
      minDaysUntilCheckin: this.rentalMinDaysUntilCheckin,
      numberOfDays: 0,
      percent: 0,
      reductions: this.priceReductionForPeriod,
      modifiedReductions: [],
      isModifiedReductions: false,
      groups: [],
      areAllRentalsChecked: false,
      checkedGroups: [],
      checkedRentals: [],
      rentals: [],
      others: [],
      modifiedGroups: [],
      rentalDependencies: this.dependencies,
      dependedRentalIds: [],
      smallLoading: false,
      getOthers: false,
      dynamicPriceField: this.dynamicPrice,
      minPrice: this.dynamicPriceSettings
        ? JSON.parse(this.dynamicPriceSettings).min_price
          ? JSON.parse(this.dynamicPriceSettings).min_price
          : ""
        : "",
      basePrice: this.dynamicPriceSettings
        ? JSON.parse(this.dynamicPriceSettings).base_price
          ? JSON.parse(this.dynamicPriceSettings).base_price
          : ""
        : "",
      specPrice: this.dynamicPriceSettings
        ? JSON.parse(this.dynamicPriceSettings).spec_price
        : "",
      listingCompetitors: this.dynamicPriceSettings
        ? JSON.parse(this.dynamicPriceSettings).listing_competitors
        : "",
    };
  },

  components: {
    VLoading: require("components/loading/loading.vue"),
  },

  mixins: [mixin],

  async mounted() {
    this.modifyReductions();
    this.smallLoading = true;
    await rentalService.getRentalsList(this);
    await rentalService.getGroups(this, true);
    await this.getOtherRentals();
  },

  methods: {
    modifyReductions() {
      const modifiedReductions = _.cloneDeep(this.reductions);
      this.modifiedReductions = modifiedReductions;
      this.isModifiedReductions = true;
    },

    deleteReduction(id, index) {
      if (this.modifiedReductions[index].isDeleting === true) {
        return;
      }
      const copyOfModifiedReductions = _.cloneDeep(this.modifiedReductions);
      copyOfModifiedReductions[index].isDeleting = true;
      this.modifiedReductions = copyOfModifiedReductions;
      if (id) {
        const data = {
          rentalId: this.rentalId,
          reductionId: id,
        };
        rentalService.deleteReduction(this, data, index);
      } else {
        this.isModifiedReductions = false;
        const reductionsToDelete = _.cloneDeep(this.reductions);
        const index = reductionsToDelete.findIndex((r) => r.id === id);
        reductionsToDelete.splice(index, 1);
        this.reductions = reductionsToDelete;
        toastr.success(this.$t("reduction_deleted"));
        this.modifiedReductions[index].isDeleting = false;
      }
    },
    updateRentalGapFillField() {
      this.$emit("updateRentalGapFillField", this.rentalGapFillField);
      if (!this.rentalGapFillField) {
        this.rentalGapFillPercentField = 0;
        this.updateRentalGapFillPercent();
      }
    },
    updateRentalGapFillPercent() {
      this.$emit("updateRentalGapFillPercent", this.rentalGapFillPercentField);
    },
    updateDynamicPrice() {
      this.$emit("updateDynamicPrice", this.dynamicPriceField);
    },
    async saveDynamicPriceSettings() {
      if (
        ((this.minPrice && this.minPrice.trim() > 0) ||
          this.minPrice.trim() === "") &&
        ((this.basePrice && this.basePrice.trim() > 0) ||
          this.basePrice.trim() === "")
      ) {
        if (this.basePrice - this.minPrice >= 0) {
          const dynamicPriceSettings = {
            id: this.rentalId,
            min_price: this.minPrice,
            base_price: this.basePrice,
            spec_price: this.specPrice,
            listing_competitors: this.listingCompetitors,
          };
          this.smallLoading = true;
          await rentalService.setDynamicPriceSettings(
            this,
            dynamicPriceSettings
          );
        } else {
          toastr.error(`${this.$t("booking.detail.dynamic_price_issue")}`);
        }
      } else {
        toastr.error(`${this.$t("booking.detail.not_positive_price")}`);
      }
    },

    closeDynamicPriceModal() {
      this.closeModalKeepValue("#dynamic-price-modal");
      this.minPrice = this.dynamicPriceSettings
        ? JSON.parse(this.dynamicPriceSettings).min_price
          ? JSON.parse(this.dynamicPriceSettings).min_price
          : ""
        : "";
      this.basePrice = this.dynamicPriceSettings
        ? JSON.parse(this.dynamicPriceSettings).base_price
          ? JSON.parse(this.dynamicPriceSettings).base_price
          : ""
        : "";
      this.specPrice = this.dynamicPriceSettings
        ? JSON.parse(this.dynamicPriceSettings).spec_price
        : "";
      this.listingCompetitors = this.dynamicPriceSettings
        ? JSON.parse(this.dynamicPriceSettings).listing_competitors
        : "";
    },

    closeReductionModal() {
      this.numberOfDays = 0;
      this.percent = 0;
      this.closeModal("#reductions");
    },

    addReduction() {
      if (this.numberOfDays === 0 || this.percent === 0) {
        toastr.error(
          `${this.$t("input.please_select")} ${this.$t("price_reduction")}`
        );
        return;
      } else if (this.percent <= 0) {
        toastr.error(this.$t("reduction-validation"));
        return;
      }
      this.isModifiedReductions = false;

      const reductions = [
        ...this.reductions,
        {
          day: this.numberOfDays,
          percent: this.percent,
          rental_id: this.rentalId,
        },
      ];
      reductions.sort((a, b) => (a.day > b.day ? 1 : b.day > a.day ? -1 : 0));
      this.reductions = reductions;
      this.numberOfDays = 0;
      this.percent = 0;
      this.closeModal("#reductions");
    },

    getOtherRentals() {
      const removed = [];
      const isGroups = this.groups.length > 0;
      // if there are not groups then all rentals will be in 'others' group
      if (!isGroups) {
        const group = {
          id: 0,
          name: this.$t("groups.all"),
          rentals: this.others,
        };
        Vue.set(this.groups, this.groups.length, group);
      }
      for (let i = 0; i < this.rentals.length; i++) {
        const rental = this.rentals[i];
        for (let j = 0; j < this.groups.length; j++) {
          const group = this.groups[j];
          const check = group.rentals.filter((r) => r.id === rental.id);
          if (check.length > 0) {
            const check1 = this.others.filter((r) => r.id === rental.id);
            if (check1.length > 0) {
              const index = this.others.indexOf(rental);
              this.others.splice(index, 1);
              break;
            }
            removed.push(rental);
          } else {
            const check2 = this.others.filter((r) => r.id === rental.id);
            if (check2.length === 0 && !removed.includes(rental)) {
              this.others.push(rental);
            }
          }
        }
      }
      // add group with rentals which are not in any groups
      if (isGroups) {
        if (this.others.length > 0) {
          const group = {
            id: 0,
            name: this.$t("groups.other"),
            rentals: this.others,
          };
          Vue.set(this.groups, this.groups.length, group);
        }
      }
      this.getOthers = true;
      return this.others;
    },
    filterByRentals(id = null) {
      if (id != null) {
        const group = this.modifiedGroups.filter((g) => g.id === id)[0];
        const groupRentals = group.rentals;
        groupRentals.map((rental) => {
          Vue.set(this.checkedRentals, rental.id, this.checkedGroups[id]);
        });
      }
      this.modifiedGroups.map((group) => {
        if (
          group &&
          group.rentals.length !== 0 &&
          !this.checkedGroups[group.id]
        ) {
          this.areAllRentalsChecked = false;
          return;
        }
        this.areAllRentalsChecked = true;
      });
      this.collectCheckedRentalIds();
    },
    showDynamicPrice() {
      return false;
      // const rentalId = parseInt(this.$route.params.id);
      // const currentRental = rentalId
      //   ? this.rentals.find((rental) => rental.id === rentalId)
      //   : null;
      // return (
      //   currentRental &&
      //   (currentRental.dynamic_price_enabled ||
      //     (!currentRental.price_lab_enabled &&
      //       !currentRental.dynamic_price_enabled))
      // );
    },
    syncDynamicPrice() {
      const rentalId = parseInt(this.$route.params.id);
      rentalService.syncPriceLab(this, rentalId);
    },
    hideAlreadyDependedRentals() {
      const rentalId = parseInt(this.$route.params.id);
      const groups = [...this.groups];
      const currentRental = this.rentals.find(
        (rental) => rental.id === rentalId
      );
      if (currentRental.is_depended) {
        this.dependedRentalIds = [
          ...this.dependedRentalIds,
          currentRental.is_depended,
        ];
      }
      this.getDependedRentalIds();
      const allGroups = [...groups];
      let depCondition = "";
      allGroups.map((group) => {
        const groupRentals = [...group.rentals];
        groupRentals.map((rental) => {
          if (currentRental.is_depended) {
            depCondition = rental.id !== currentRental.is_depended;
          } else {
            depCondition =
              (rental.has_any_dependency &&
                !this.dependedRentalIds.includes(rental.id)) ||
              rentalId === rental.id;
          }
          if (depCondition) {
            const index = group.rentals.findIndex(
              (groupRental) => groupRental.id === rental.id
            );
            if (index !== -1) {
              group.rentals.splice(index, 1);
            }
          }
        });
        if (!group.rentals.length) {
          const groupIndex = groups.findIndex((g) => g.id === group.id);
          if (groupIndex !== -1) {
            groups.splice(groupIndex, 1);
          }
        }
      });
      this.modifiedGroups = groups;
      this.smallLoading = false;
      this.collectCheckedRentalIds();
    },
    collectCheckedRentalIds() {
      for (let i = 0; i < this.modifiedGroups.length; i++) {
        const group = this.modifiedGroups[i];
        for (let j = 0; j < group.rentals.length; j++) {
          const rental = group.rentals[j];
          if (!this.checkedRentals[rental.id]) {
            Vue.set(this.checkedGroups, group.id, false);
            break;
          }
          Vue.set(this.checkedGroups, group.id, true);
        }
      }
      this.$emit("handleDependentRentalIds", this.checkedRentals);
    },
    getDependedRentalIds() {
      this.rentalDependencies.map((dep) => {
        this.dependedRentalIds = [...this.dependedRentalIds, dep.dep_rental_id];
      });
      this.dependedRentalIds.map((key) => {
        this.checkedRentals[key.toString()] = true;
      });
      this.$forceUpdate();
    },
  },
  watch: {
    reductions(val) {
      this.modifyReductions(val);
      this.$emit("updateRentalPriceReduction", val);
    },
    defaultInventoryField(val) {
      this.$emit("updateRentalDefaultInventoryField", val);
    },
    minDaysUntilCheckin(val) {
      this.$emit("updateRentalMinDaysUntilCheckin", val);
    },
    getOthers(val) {
      if (val && this.getOthers) {
        this.hideAlreadyDependedRentals();
      }
    },
  },
  computed: {
    account() {
      return this.$store.state.account;
    },
  },
};
</script>



// WEBPACK FOOTER //
// SpecialFeatures.vue?0707cb11